import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {withFlexHolder} from '@/hocs/withFlex';
import Link from '@/links';
import styles from './styles.module.scss';

const propTypes = {
  lightHeader: PropTypes.bool,
  isLogoCentered: PropTypes.string
};

const LogoPrimary = dynamic(() => import('@/svg/logos/logoPrimary'), {loading: () => null});

const H = props => <header {...props} />;
const FlexHeader = withFlexHolder(H);

const HeaderNoMenu = ({lightHeader, isLogoCentered}) => {
  const rowProps = {
    center: isLogoCentered ? 'xs' : undefined
  };

  return (
    <FlexHeader className={`${styles['header-no-menu']}`}>
      <Container>
        <Grid fluid>
          <Row middle="xs" {...rowProps}>
            <Col xs={12}>
              <Link href="/" title="Workable logo">
                <LogoPrimary lightHeader={lightHeader} />
              </Link>
            </Col>
          </Row>
        </Grid>
      </Container>
    </FlexHeader>
  );
};

HeaderNoMenu.propTypes = propTypes;

export default HeaderNoMenu;
